import { render } from "./ClassroomStudent.vue?vue&type=template&id=1b875f19"
import script from "./ClassroomStudent.vue?vue&type=script&lang=js"
export * from "./ClassroomStudent.vue?vue&type=script&lang=js"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-director-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__